export default "__VITE_ASSET__ZHP$r4Cf__"